import { useUpdateHabitOrderMutation } from 'shared/hooks/queries/use-update-habit-order-mutation';

export const useUpdateHabitOrder = () => {
  const { mutate: updateOrder } = useUpdateHabitOrderMutation();

  return updateOrder;
};
